var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-16 flex flex-col"},[_c('h1',{staticClass:"text-3xl"},[_vm._v("\n\t\tThank You\n\t")]),_vm._v("\n\tThanks, you have been put on our business claim wait list.\n\t"),_c('br'),_vm._v("\n\tA representative will contact you shortly.\n")])
}]

export { render, staticRenderFns }